import React from 'react';

import { Loader } from '@cowbell/ui';

/**
 * The public routes are imported by the entry chunk. A static import of this page took the form
 * engine and its dependencies with it, which grew the vendor chunk's source map past the 25 MiB
 * Cloudflare Pages accepts. Loaded on demand, the form engine stays in its own chunks.
 */
const RiskDataFlowPage = React.lazy(() =>
  import('./RiskDataFlowPage').then((module) => ({
    default: module.RiskDataFlowPage,
  }))
);

export function LazyRiskDataFlowPage() {
  return (
    <React.Suspense fallback={<Loader />}>
      <RiskDataFlowPage />
    </React.Suspense>
  );
}
